import { getCurrentProductSubscriptionDetail } from "shared/utility/ProductSubscriptionHelper";
import Subscription from "interfaces/response/Subscription";
import WidgetPanel from "components/common/WidgetPanel";
import { RootState } from "store/store";
import { connect } from "react-redux";
import { TokenStatus } from "shared/enums/TokenStatusEnum";
import LinkButton from "components/common/LinkButton";
import { useHistory } from "react-router-dom";
import * as routePath from "shared/constants/RoutePathConstants";
import { getFormattedNumber } from "shared/utility/NumberUtility";

interface Props {
  activeKeyCount?: number;
  inactiveKeyCount?: number;
  expiredKeyCount?: number;
}

export function TokenSummary(props: Props) {
  const { activeKeyCount, inactiveKeyCount, expiredKeyCount } = props;
  const history = useHistory();

  const handleEditTokenClick = () => {
    history.push(routePath.TOKENS);
  };

  const getKeyCountText = (numberOfKey: number = 0) => {
    const formattedKeyCount = getFormattedNumber(numberOfKey);
    if (numberOfKey > 1) {
      return `${formattedKeyCount} keys`;
    }
    return `${formattedKeyCount} key`;
  };

  const getTitle = () => {
    return "API tokens";
  };

  return (
    <WidgetPanel
      displayHeader={false}
      displaySecondaryHeaderOnSmallScreen
      title={getTitle()}
    >
      <div className="flex">
        <div className="flex-grow-0 font-semibold mr-8 hidden lg:inline-block text-sm">
          {getTitle()}
        </div>
        <div className="flex flex-grow flex-col lg:flex-row gap-y-2 gap-x-4 text-sm font-semibold">
          <div className="inline-block">
            <span className="text-promDeepMint mr-1">ACTIVE:</span>
            <span>{getKeyCountText(activeKeyCount)}</span>
          </div>
          <div className="inline-block">
            <span className="text-promBlue1 mr-1">INACTIVE:</span>
            <span>{getKeyCountText(inactiveKeyCount)}</span>
          </div>
          <div className="inline-block">
            <span className="text-promRed1 mr-1">EXPIRED:</span>
            <span>{getKeyCountText(expiredKeyCount)}</span>
          </div>
        </div>
        <div className="flex-grow-0 flex-shrink-0 flex justify-items-end">
          <LinkButton
            className="mr-4 float-right mt-auto"
            onClick={handleEditTokenClick}
          >
            edit tokens
          </LinkButton>
        </div>
      </div>
    </WidgetPanel>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  const currentSubscription: Subscription | null =
    getCurrentProductSubscriptionDetail(state);
  const licenseKeys = currentSubscription?.keys || [];

  let activeKeyCount = 0;
  let inactiveKeyCount = 0;
  let expiredKeyCount = 0;

  licenseKeys.forEach((key) => {
    if (key.status === TokenStatus.Expired) {
      expiredKeyCount++;
    } else if (key.status === TokenStatus.Active) {
      activeKeyCount++;
    } else {
      inactiveKeyCount++;
    }
  });

  return {
    activeKeyCount,
    inactiveKeyCount,
    expiredKeyCount,
  };
};

export default connect(mapStateToProps)(TokenSummary);
